import { useState, useEffect, useCallback } from 'react';
import api from '../../api';
import { urlEliminazione, messaggioEliminazione, avvisaConflitto } from '../../utils/eliminazione';
import Layout from '../../components/Layout';
import stili from '../../components/competenze/stili';
import ConflittoVersione, { eConflitto } from '../../components/ConflittoVersione';
import { usePuoScrivere } from '../../utils/permessi';

// Tipi e categorie dello Scadenziario, modificabili senza toccare il codice
export default function TipiCategorie() {
  const puoScrivere = usePuoScrivere('scadenziario');
  const [dati, setDati] = useState({ tipi: [], categorie: [] });
  const [inModifica, setInModifica] = useState(null); // { genere: 'tipi'|'categorie', voce, tipo_id? }
  const [errore, setErrore] = useState('');

  const carica = useCallback(() => {
    api.get('/scadenze/tipi').then(r => setDati(r.data)).catch(err => setErrore(err.response?.data?.errore || 'Errore nel caricamento'));
  }, []);
  useEffect(() => { carica(); }, [carica]);

  const elimina = async (genere, voce) => {
    if (!window.confirm(`Spostare nel Cestino "${voce.nome}"? Le voci dello Scadenziario già registrate non cambiano.`)) return;
    try { await api.delete(urlEliminazione(`/scadenze/${genere}/${voce.id}`, voce.version)); carica(); } catch (err) { setErrore(avvisaConflitto(err, messaggioEliminazione(err))); if (eConflitto(err)) carica(); }
  };

  return (
    <Layout>
      <div style={stili.topBar}>
        <h2 style={{ margin: 0 }}>Tipi e categorie</h2>
        {puoScrivere && <button onClick={() => setInModifica({ genere: 'tipi', voce: null })} style={stili.btn}>+ Nuovo tipo</button>}
      </div>
      {errore && <div style={stili.errore}>{errore}</div>}
      {dati.tipi.map(t => (
        <div key={t.id} style={{ background: 'white', borderRadius: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', padding: '1rem', marginBottom: '1rem', opacity: t.attivo ? 1 : 0.55 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
            <h3 style={{ margin: 0 }}>{t.nome}{!t.attivo && <small style={{ color: '#999' }}> (non attivo)</small>}</h3>
            {puoScrivere && (
              <div>
                <button onClick={() => setInModifica({ genere: 'categorie', voce: null, tipo_id: t.id })} style={stili.btnSmall}>+ Categoria</button>
                <button onClick={() => setInModifica({ genere: 'tipi', voce: t })} style={stili.btnSmall}>Modifica</button>
                <button onClick={() => elimina('tipi', t)} style={stili.btnSmallDanger}>Elimina</button>
              </div>
            )}
          </div>
          <ul style={{ margin: '0.6rem 0 0', paddingLeft: '1.1rem' }}>
            {dati.categorie.filter(c => c.tipo_id === t.id).map(c => (
              <li key={c.id} style={{ padding: '0.2rem 0', opacity: c.attiva ? 1 : 0.55 }}>
                {c.nome}{c.collocamento && <small style={{ color: '#6b6b2f' }}> (collocamento)</small>}{!c.attiva && <small style={{ color: '#999' }}> (non attiva)</small>}
                {puoScrivere && (
                  <>
                    <button onClick={() => setInModifica({ genere: 'categorie', voce: c, tipo_id: c.tipo_id })} style={{ ...stili.btnSmall, marginLeft: '0.6rem' }}>Modifica</button>
                    <button onClick={() => elimina('categorie', c)} style={stili.btnSmallDanger}>Elimina</button>
                  </>
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}
      {inModifica && (
        <FormVoce
          {...inModifica}
          tipi={dati.tipi}
          onChiudi={() => setInModifica(null)}
          onSalvato={() => { setInModifica(null); carica(); }}
        />
      )}
    </Layout>
  );
}

function FormVoce({ genere, voce, tipo_id, tipi, onChiudi, onSalvato }) {
  const campoAttivo = genere === 'tipi' ? 'attivo' : 'attiva';
  const daVoce = v => ({ nome: v?.nome || '', ordine: v?.ordine ?? 0, tipo_id: v?.tipo_id || tipo_id || '', collocamento: Boolean(v?.collocamento), [campoAttivo]: v ? v[campoAttivo] : true, version: v?.version });
  const [form, setForm] = useState(daVoce(voce));
  const [errore, setErrore] = useState('');
  const [conflitto, setConflitto] = useState(null);

  const salva = async (version) => {
    setErrore('');
    try {
      if (voce) await api.put(`/scadenze/${genere}/${voce.id}`, { ...form, version });
      else await api.post(`/scadenze/${genere}`, form);
      onSalvato();
    } catch (err) {
      if (eConflitto(err)) setConflitto(err.response.data);
      else setErrore(err.response?.data?.errore || 'Errore nel salvataggio');
    }
  };

  return (
    <div style={stili.overlay}>
      <div style={{ ...stili.modal, maxWidth: '460px' }}>
        <h3 style={{ marginTop: 0 }}>{voce ? 'Modifica' : 'Nuovo'} {genere === 'tipi' ? 'tipo' : 'categoria'}</h3>
        <form onSubmit={e => { e.preventDefault(); salva(form.version); }}>
          {errore && <div style={stili.errore}>{errore}</div>}
          <div style={stili.campo}>
            <label style={stili.label}>Nome</label>
            <input autoFocus value={form.nome} onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} required style={stili.input} />
          </div>
          {genere === 'categorie' && (
            <div style={stili.campo}>
              <label style={stili.label}>Tipo</label>
              <select value={form.tipo_id} onChange={e => setForm(f => ({ ...f, tipo_id: e.target.value }))} style={stili.input} required>
                {tipi.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
              </select>
            </div>
          )}
          <div style={stili.campo}>
            <label style={stili.label}>Ordine (numero, per l'elenco)</label>
            <input type="number" value={form.ordine} onChange={e => setForm(f => ({ ...f, ordine: e.target.value }))} style={stili.input} />
          </div>
          {genere === 'categorie' && (
            <label style={{ fontSize: '0.88rem', display: 'flex', gap: '0.4rem', alignItems: 'center', marginBottom: '0.5rem' }}>
              <input type="checkbox" checked={form.collocamento} onChange={e => setForm(f => ({ ...f, collocamento: e.target.checked }))} />
              Pratica di collocamento (si può portare in Competenze)
            </label>
          )}
          {voce && (
            <label style={{ fontSize: '0.88rem', display: 'flex', gap: '0.4rem', alignItems: 'center' }}>
              <input type="checkbox" checked={form[campoAttivo]} onChange={e => setForm(f => ({ ...f, [campoAttivo]: e.target.checked }))} />
              Attivo (se tolto non compare più tra le scelte)
            </label>
          )}
          <div style={stili.azioni}>
            <button type="button" onClick={onChiudi} style={stili.btnSecondary}>Annulla</button>
            <button type="submit" style={stili.btn}>Salva</button>
          </div>
        </form>
      </div>
      {conflitto && (
        <ConflittoVersione
          conflitto={conflitto}
          onRicarica={() => { setForm(daVoce(conflitto.attuale)); setConflitto(null); }}
          onSovrascrivi={() => salva(conflitto.attuale.version)}
        />
      )}
    </div>
  );
}
